import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Navbar from "./Landingpages/layouts/Navbar";
import './App.css';
import Cloud from "./Landingpages/Cloud.jsx"
import Maamaasuser from "./Landingpages/Maamaasuser.js";

import Newnavbar from './Landingpages/layouts/Newnavbar.js'
import Newmenuiteam from './Landingpages/Newmenuiteam.js'
import React from "react";
import Cartsdata from './Landingpages/Cartsdata.js';

import Profilepage from './Landingpages/Profile/Profilepage.js';
// import Digitalfoodall from './pages/modules/Component/Digitalfood/Digitalfoodall';

import Forgetpassword from './Landingpages/Forgetpassword.js';
import Termscondition from './Landingpages/Termscondition.js';
import AuthPage from './Landingpages/auth/AuthPage.jsx';

function Layout() {
  const [showLogin, setShowLogin] = React.useState(false);
  const location = useLocation();
  const showLayout =
    location.pathname === "/homepage" ||
    location.pathname === "/donations" ||
    location.pathname === "/news" ||
    location.pathname === "/events" ||
    location.pathname === "/bookings" ||
    location.pathname === "/Cloud";

  const showLayout1 =
    location.pathname === "/Maamaasuser/:vendorId" ||
    location.pathname === "/Newmenuiteam" ||
    location.pathname === "/cartsdata" ||
    location.pathname === "/profilepage" ||
    // location.pathname === "/Digitalfoodall" ||
    location.pathname === "/Forgetpassword" ||
    location.pathname === "/Termscondition";


  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      {showLayout && <Navbar showLogin={showLogin} setShowLogin={setShowLogin} />}
      {showLayout1 && <Newnavbar showLogin={showLogin} setShowLogin={setShowLogin} />}
      <div style={{ display: "flex", flexGrow: 1 }}>
        {/* {showLayout && <Mainsidebar />} */}
        <div style={{ flexGrow: 1 }}>
          <Routes>
            <Route path="/" element={<AuthPage />} />
            <Route path="/homepage" element={<Cloud />} />
            {/* <Route path="/" element={<Home />} /> */}
            <Route path="/Maamaasuser/:vendorId" element={<Maamaasuser />} />
            <Route path="/Newmenuiteam" element={<Newmenuiteam setShowLogin={setShowLogin} />} />
            <Route path="/cartsdata" element={<Cartsdata />} />
            <Route path="/profilepage" element={<Profilepage />} />
            {/* <Route path="/Digitalfoodall" element={<Digitalfoodall />} /> */}
            <Route path="/Forgetpassword" element={<Forgetpassword />} />
            <Route path="/Termscondition" element={<Termscondition />} />
          </Routes>
        </div>
      </div>
    </div>
  );
}

function App() {

  return (
    <Router>
      <Layout />
    </Router>
  );
}

export default App;

